export const
    fetch_logo = require('./logo-fetch-blue-knockout-sm.svg'),
    logo = require('./logo-supplydrop.svg'),
    localeur_logo = require('./localeur_logo.svg'),
    facebook_logo = require('./facebook-logo.svg'),
    twitter_logo = require('./twitter-logo.svg'),
    navigation_share = require('./navigation-share.svg'),
    instagram_logo = require('./instagram_logo.svg'),
    linkedin_logo = require('./linkedin_logo.svg')